import { createClient } from '@supabase/supabase-js'

const SUPABASE_URL = 'https://flvtyyjqgveiiqnlcfav.supabase.co'
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImZsdnR5eWpxZ3ZlaWlxbmxjZmF2Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODI0Mjk2NjksImV4cCI6MjA5ODAwNTY2OX0.qQKpFSwaSD_kPiaNpYuWD_84Y3HNfkQKFUawdJTSpbk'

if(!SUPABASE_URL || !SUPABASE_ANON_KEY ){
  throw new Error('Missing Supabase variables');
}

export default createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true
  }
})